import * as React from 'react';
import styled from 'styled-components';

// ############################ Imported from Old UI ###########################

// tslint:disable-next-line:variable-name
const StyledLayout = styled.div<{}>(
  ({ theme }) => `
  width:100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  border-radius: ${theme.borderRadiusCommon}px;
  margin: 0 auto;
`
);

// tslint:disable-next-line:variable-name
const StyledLayoutMain = styled.main<{}>(
  ({ theme }) => `
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.white};
  overflow: hidden;
`
);

// eslint-disable-next-line arrow-body-style
const ApplyOnlineLayoutSimple: React.FC = (props) => {
  return (
    <StyledLayout>
      <StyledLayoutMain>{props.children}</StyledLayoutMain>
    </StyledLayout>
  );
};

export default ApplyOnlineLayoutSimple;
